define('cart_promocode_notifications.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('cart_promocode_notifications', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " ";
},"useData":true}, 'extensions/Tavano/TT_Master_Theme_CapitolScientific/1.1.2/', 'extensions/Tavano/TT_Master_Theme_CapitolScientific/1.1.2/', Handlebars);
});